import { ROUTER_TYPE } from '@/utils/constant'
import qwertycheck from './qwertycheck'
export const appConfig = {
    qwertycheck,
    default: {
        lang: 'en',
        company: 'usheis.com',
        name: 'Usheis',
        email: 'wbkadmail1@163.com',
        fbPixel: {
            1: '1438847163760449',
            2: '1789737104944898',
        },
        adx: {
            1: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_1',
            2: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_2',
            3: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_3',
        },
        ga4: {
            id: 'G-JR9JHZ3DYK'
        },
        adConfig: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 550,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 20,
            // 遮照显示比率 小于 参数都生效
            showMaskProbability: 1,
        },
        taboolaConfig: {
            publisher_id: 'newstech-network',
            idfpConfig: {
                1: {
                    // 广告类型
                    mode: 'thumbnails-a-tu',
                    // 广告标识
                    placement: 'Article Page thumbnails_textunder'
                }
            }
        },
        content:{
            1: {
                split: '\n\n',
                textNum: 300,
                p: 3,
            },
        },
        routerType: {
            1: ROUTER_TYPE.TABOOLA,
        },
        pixelReport: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}